// extracted by mini-css-extract-plugin
export default {"EmbedCollapsingSection":"styles__EmbedCollapsingSection__DL3_W"};